import React from 'react';
import {BareAccount} from "../../../model/Scheme/BareAccount";
import AccountWidget from "../../Shared/AccountWidget";
import {createOperationRoute} from '~/redux/finances/financesRouting';

interface UseAccountSelectionProps {
    readonly fromAccount: BareAccount;

    readonly fromAccounts: BareAccount[];

    readonly toAccount: BareAccount;

    readonly toAccounts: BareAccount[];
}

export const renderAccountSelection = ({
    fromAccount,
    fromAccounts,
    toAccount,
    toAccounts,
}: UseAccountSelectionProps) => {
    return {
        From: (
            <AccountWidget
                modalTitle='From account'
                account={fromAccount}
                accounts={fromAccounts}
                buildPath={selectedAccount =>
                    createOperationRoute(
                        'exchange',
                        {type: 'fiat', id: selectedAccount.id},
                        {type: 'fiat', id: selectedAccount.id === toAccount.id ? fromAccount.id : toAccount.id}
                    )
                }
            />
        ),
        To: (
            <AccountWidget
                modalTitle='To account'
                account={toAccount}
                accounts={toAccounts}
                buildPath={selectedAccount =>
                    createOperationRoute(
                        'exchange',
                        {type: 'fiat', id: selectedAccount.id === fromAccount.id ? toAccount.id : fromAccount.id},
                        {type: 'fiat', id: selectedAccount.id}
                    )
                }
            />
        ),
    };
};
